
export default {
    namespace:true,
    state:{
        option:null
    },
    mutations:{
        setOption(state, payload){
            state.option = payload;
        }
    },
    actions:{
        cambiarOption({commit}, payload){
            commit("setOption", payload);
        }

    },
    getters:{

    }
}